{
  "full_report_url": "https://unctad.org/system/files/official-document/osginf2026d3_en.pdf",
  "more_reports_url": "https://unctad.org/publications-search?f[0]=product%3A412",
  "show_site_header": true,
  "subtitle": "The burden of oil price shocks on vulnerable economies",
  "title": "Strait of Hormuz Disruptions",
  "url": "https://unctad.org/publication/strait-hormuz-disruptions-burden-oil-price-shocks-vulnerable-economies"
}
